<!-- File: NavItems.vue -->
<template>
  <ul class="navigation">
    <li><router-link to="/">Beranda</router-link></li>
    <!-- <li><router-link to="/berita">Berita</router-link></li> -->

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Informasi</a>
      <ul class="sub-menu">
        <li><router-link to="/BeritaOPD">Berita</router-link></li>
        <li>
          <a href="https://konaweselatankab.go.id/agenda_pengumuman/pengumuman/list" target="_blank" rel="noopener noreferrer">
            Pengumuman
          </a>
        </li>
      </ul>
    </li>

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Profil</a> 
      <ul class="sub-menu">
        <li><router-link to="/TugasPokok">Tugas Pokok</router-link></li>
        <li><router-link to="/StrukturOrganisasi">Struktur Organisasi</router-link></li>
        <li><router-link to="/TujuanSasaran">Tujuan & Sasaran</router-link></li>  
      </ul>
    </li>
    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Unit Kerja</a>
      <ul class="sub-menu"> 
        <li><router-link to="/SekretariatOPD">Sekretariat</router-link></li>
        <li><router-link to="/PenyiapanKawasandanPembangunanTransmigrasi"> Penyiapan Kawasan dan Pembangunan Transmigrasi</router-link></li>
        <li><router-link to="/PembinaandanPengembanganKawasanTransmigrasi"> Pembinaan dan Pengembangan Kawasan Transmigrasi </router-link></li>
        <li><router-link to="/HubunganIndustrialdanPerlindunganTenagaKerja"> Hubungan Industrial dan Perlindungan Tenaga Kerja </router-link></li>
        <li><router-link to="/PenempatandanPelatihanTenagaKerja"> Penempatan dan Pelatihan Tenaga Kerja </router-link></li>
 
      </ul>
    </li> 
    
    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Data dan Informasi</a>
      <ul class="sub-menu">
        <li><router-link to="/DataUmum">Data Umum</router-link></li>  
        <li><router-link to="/DataPerizinan">Data Perizinan</router-link></li>  
        <li><router-link to="/DataPPID">Data PPID</router-link></li>  
        <li><router-link to="/DataUMK">Data UMK</router-link></li>  
        <li><router-link to="/DataUPTD">Data UPTD</router-link></li>  
      </ul>
    </li> 

    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Layanan</a>
      <ul class="sub-menu">

        <li><router-link to="/LayananPekerjaan">Layanan Pekerjaan</router-link></li>
        <li><router-link to="/LayananPeraturan">Layanan Peraturan</router-link></li>
        <li><router-link to="/LayananHubunganIndustri">Layanan Hubungan Industri</router-link></li>
        <li><router-link to="/LayananPelatihanKerja">Layanan Pelatihan Kerja</router-link></li>
        <li><router-link to="/LayananPenempatanTenagaKerja">Layanan Penempatan Tenaga Kerja</router-link></li>
        <li><router-link to="/LayananPengawasanTenagaKerja">Layanan Pengawasan Tenaga Kerja</router-link></li>
      </ul>
    </li> 

    <!-- <li><router-link to="/DataLainnya">Dokumen Lainnya</router-link></li> -->
    <li class="menu-item-has-children">
      <a href="javascript:void(0);">Galeri</a>
      <ul class="sub-menu">
        <li><router-link to="/FotoOPD">Foto</router-link></li>
        <li><router-link to="/VideoOPD">Video</router-link></li>
      </ul>
    </li>
    <!-- <li><a target="_blank" href="https://drive.google.com/file/d/1Ay_wpCE_ho4tOODoUUnjB-Wkh_uUYKtd/view">Firetap</a></li> -->



  </ul>
</template>
